import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Swipe from 'react-easy-swipe';

import history from 'config/history';

import SpogLink from 'router-with/ui/SpogLinkRoute';

import Icon from 'components/ui/element/Icon';
import HeaderSettings from 'components/ui/layout/HeaderSettings';

import {isMobile, getMatchRoute} from 'util/utils';

import 'style/components/ui/layout/nav/sidebar.scss';

class Sidebar extends Component {

    static propTypes = {
        onToggle: PropTypes.func.isRequired, // Listener when the sidebar was toggled
        routes:   PropTypes.array.isRequired, //The routes to render
        user:     PropTypes.object, // The logged user
        onLogout: PropTypes.func, // Listener when the user does logout
        opened:   PropTypes.bool // True when the sidebar is opened
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleRouteToggleClick = this.handleRouteToggleClick.bind(this);
        this.handleSwipe = this.handleSwipe.bind(this);
    }

    /**
     * Prevent default also bubble onToggle event
     * @param {Event} e The event object
     */
    handleToggleClick(e) {
        e && e.preventDefault();
        const { onToggle } = this.props;

        onToggle();
    }

    /**
     * If you click on the sidebar element that will navigate somewhere else, and if it is mobile, it will
     * close the sidebar
     */
    handleRouteToggleClick() {
        if (isMobile()) {
            this.handleToggleClick();
        }
    }

    handleSwipe() {
        const {opened} = this.props;

        if (opened) {
            this.handleRouteToggleClick();
        }
    }

    render() {
        const {routes, intl:{formatMessage}, user, onLogout} = this.props;
        // Dynamic sidebar links from routes definition

        const match = getMatchRoute(routes, history.location.pathname, true);
        const links = routes.map(route => {
            const url = `${route.path}`;

            if (route.onlyInternals) {
                return null;
            }

            if ((route.extra && route.extra.icon) || (route.extra && route.extra.iconClass)) {
                const liClassName = `sidebar-list ${match === route ? 'active' : ''}`;

                if (route.extra.icon) {
                    return (
                        <li className={liClassName} key={route.path}>
                            <SpogLink to={url} onClick={this.handleRouteToggleClick}>
                                <span>{formatMessage({id: route.extra.name})}<Icon name={route.extra.icon} fw={true} eqx={true} className="menu-icon" /></span>
                            </SpogLink>
                        </li>
                    );
                }

                // NO se usa por ahora
                if (route.extra.iconClass) {
                    return (
                        <li className={liClassName} key={route.path}>
                            <SpogLink to={url} onClick={this.handleRouteToggleClick}>
                                <span>{formatMessage({id: route.extra.name})}<i className="icon icon-support menu-icon"/></span>
                            </SpogLink>
                        </li>
                    );
                }
            }

            return null;
        });

        const internalLinks = (
            <li className="sidebar-internals">
                {routes.map(route => {
                    const url = `${route.path}`;

                    if (route.onlyInternals) {
                        if ((route.extra && route.extra.icon) || (route.extra && route.extra.iconClass)) {
                            const liClassName = `sidebar-list ${match === route ? 'active' : ''}`;

                            if (route.extra.icon) {
                                return (
                                    <li className={liClassName} key={route.path}>
                                        <SpogLink to={url} onClick={this.handleRouteToggleClick}>
                                            <span>{formatMessage({id: route.extra.name})}<Icon name={route.extra.icon} fw={true} className="menu-icon" /></span>
                                        </SpogLink>
                                    </li>
                                );
                            }

                            // NO se usa por ahora
                            if (route.extra.iconClass) {
                                return (
                                    <li className={liClassName} key={route.path}>
                                        <SpogLink to={url} onClick={this.handleRouteToggleClick}>
                                            <span>{formatMessage({id: route.extra.name})}<i className="icon icon-support menu-icon"/></span>
                                        </SpogLink>
                                    </li>
                                );
                            }
                        }

                    }

                    return null;
                })}
            </li>
        );

        return (
            <Swipe onSwipeLeft={this.handleSwipe}>
                <div className="sidebar-container">
                    <ul className="sidebar">
                        <li className="sidebar-main">
                            <SpogLink to="/">
                                <img alt="logo" src={require('img/equinix_logo.svg')}/>
                                <Icon id="toggle-sidebar" onClick={this.handleToggleClick} name="navicon" className="menu-icon"/>
                            </SpogLink>
                        </li>
                        <li className="sidebar-user">
                            <HeaderSettings
                                user={user}
                                onLogout={onLogout}
                                onClick={this.handleRouteToggleClick}
                            />
                        </li>
                        {user.canImpersonate ? internalLinks : null}
                        {links}
                    </ul>
                </div>
            </Swipe>
        );
    }
}

export default injectIntl(Sidebar);



// WEBPACK FOOTER //
// ./src/components/ui/layout/nav/Sidebar.jsx